/**
 * Attach a delegated event handler to an element in the DOM.
 *
 * Use this function to listen for events from a specific element; this is
 * especially useful if you want to listen the events on elements that leave and
 * enter the DOM frequently.
 *
 * @example
 *
 *     <!-- DOM -->
 *     <ul id="todo-list">
 *       <li class="todo">Todo #1</li>
 *       <li class="todo">Todo #2</li>
 *     </ul>
 *
 *     // JS
 *     onEvent(document.body, 'click', 'li.todo', (event, liElement) => {
 *       markTodoAsDone(...)
 *     })
 *
 * In the above example, we don't have to attach new event listeners as todo
 * items are added or removed from the DOM.
 *
 * @param {HTMLElement} el the element to attach an event listener to.
 * @param {String} eventType the type of event to listen for.
 * @param {String} selector query selector of the descendant element or node
 *    that we are attaching the handler to.
 * @param {*} handler function invoked with the event and the matching
 *    descendant element.
 */
const onEvent = (el, eventType, selector, handler) => {
  el.addEventListener(eventType, ev => {
    const target = ev.target.closest(selector)
    if (!target) {
      return
    }

    handler(ev, target)
  })
}

export { onEvent }



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/utils/eventUtils.js